import {
    Stack,
    Card,
    Container,
    Typography,
    Box,
    Tabs,
    Tab,
    CardContent,
    Button
} from '@mui/material'
import { Call } from '@mui/icons-material';
import * as api from '../api/PhoneBook'
import { useEffect, useState, useContext } from 'react'
import { ProfileContext } from '../../src/contexts/ProfileContext'
import { BackDropLoading } from '../ui-component';
import * as dict from '../dictionary/PhoneBook'

export const PhoneBookREM = () => {

    const [profile, setProfile] = useState(null);
    const [houseInfo, setHouseInfo] = useState(null)
    const [otherList, setOtherList] = useState([])
    const [emergencyList, setEmergencyList] = useState([])
    const [isTabSelected, setIsTabSelected] = useState(0)
    const [loading, setLoading] = useState(false)
    const context = useContext(ProfileContext)

    const handleTabSelected = (newValue) => {
        window.scrollTo(0, 0);
        setIsTabSelected(newValue)
    }

    useEffect(() => {
        const loadPhoneBookListV1 = async () => {
            let res = await api.getPhoneBookListV1({
                "line_id": profile?.line_id,
                "product_type": houseInfo?.product_type,
                "project_id": houseInfo?.project_id
            })
            let data = res.data?.Data
            setOtherList(data)
        }
        if (houseInfo !== null) {
            loadPhoneBookListV1()
        }
    }, [profile, houseInfo]);

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

        if (context?.state.houseInfo) {
            setHouseInfo(context?.state?.houseInfo)
        }
    }, [context])

    return (
        <>
            <div style={{ height: "calc(100vh - 108px)" }} >
                <Container maxWidth="xl" sx={{ paddingTop : 5}}>
                    <Stack spacing={1}>
                        {otherList?.map((element, index) => (
                            <Card key={index} variant="outlined" sx={{ minWidth: 275, borderRadius: "10px"}}>
                                <CardContent>
                                    <Stack direction="row" justifyContent="space-between" alignItems={"center"}>
                                        <Stack direction="column"
                                            justifyContent="center"
                                            alignItems="flex-start"
                                            spacing={1}
                                            style={{ width: '100%' }}
                                        >
                                            <Typography variant="h6" >
                                                {element.Title}
                                            </Typography>
                                            <Stack style={{ gap: '20px', width: '100%' }}>
                                                {element.PhoneBooks.map((phone, phoneIndex) => (
                                                    <Stack key={phoneIndex} direction="column" spacing={1}>
                                                        <Typography variant="body2">
                                                            {phone.Title}
                                                        </Typography>
                                                        {phone.PhoneBooks.map((phoneDetail, phoneDetailIndex) => (
                                                            <Stack key={phoneDetailIndex} direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{ width: '100%', pl: 1 }}>
                                                                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
                                                                    <a href={`tel:${phoneDetail.Value}`}>{phoneDetail.Value}</a>
                                                                </Typography>
                                                                {phoneDetail.Type !== 'Remark' && (
                                                                    <a href={`tel:${phoneDetail.Value}`}>
                                                                        <Button variant="contained" size="small">
                                                                            <Call />
                                                                        </Button>
                                                                    </a>
                                                                )}
                                                            </Stack>
                                                        ))}
                                                    </Stack>
                                                ))}
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                            </Card>
                        ))}
                    </Stack>
                </Container>

                <BackDropLoading
                    loading={loading}
                />
            </div>
        </>
    )
}